// extracted by mini-css-extract-plugin
module.exports = {"ctaFullWidth":"article-news-toolbar_ctaFullWidth__xmHD_"};